<template>
  <a-spin :spinning="confirmLoading">
    <j-form-container :disabled="formDisabled" class="record-model-form">
      <a-form-model
        :label-col="{ span: 5 }"
        :model="model"
        :rules="validatorRules"
        :wrapper-col="{ span: 12 }"
        ref="form"
        slot="detail"
      >
        <a-row :gutter="24">
          <a-col :span="8">
            <a-form-model-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="入库时间" prop="warehousingTime">
              <j-date
                :showTime="true"
                dateFormat="YYYY-MM-DD HH:mm:ss"
                placeholder="请选择入库时间"
                style="width: 100%"
                v-model="model.warehousingTime"
              />
            </a-form-model-item>
          </a-col>
          <a-col :span="8">
            <a-form-model-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="采购总金额(元)" prop="totalAmount">
              <a-input-number disabled placeholder="请输入采购总金额" style="width: 100%" v-model="model.totalAmount" />
            </a-form-model-item>
          </a-col>
          <a-col :span="8">
            <a-form-model-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="登记时间" prop="registerTime">
              <j-date
                :showTime="true"
                dateFormat="YYYY-MM-DD HH:mm:ss"
                placeholder="请选择登记时间"
                style="width: 100%"
                v-model="model.registerTime"
              />
            </a-form-model-item>
          </a-col>
        </a-row>
        <a-row :gutter="24">
          <a-col :span="8">
            <a-form-model-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="负责人" prop="headId">
              <j-search-select-tag
                :async="true"
                :pageSize="100"
                dict="sys_user,realname,id"
                placeholder="请选择负责人"
                tenant="rel_tenant_ids"
                v-model="model.headId"
              ></j-search-select-tag>
            </a-form-model-item>
          </a-col>
          <a-col :span="8">
            <a-form-model-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="验收人" prop="acceptorId">
              <j-search-select-tag
                :async="true"
                :pageSize="100"
                dict="sys_user,realname,id"
                placeholder="请选择验收人"
                tenant="rel_tenant_ids"
                v-model="model.acceptorId"
              ></j-search-select-tag>
            </a-form-model-item>
          </a-col>
          <a-col :span="8">
            <a-form-model-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="提资人" prop="tzrId">
              <j-search-select-tag
                :async="true"
                :pageSize="100"
                dict="sys_user,realname,id"
                placeholder="请选择提资人"
                tenant="rel_tenant_ids"
                v-model="model.tzrId"
              ></j-search-select-tag>
            </a-form-model-item>
          </a-col>
        </a-row>
        <a-row :gutter="24">
          <a-col :span="16">
            <a-form-model-item :labelCol="labelCol2" :wrapperCol="wrapperCol2" label="备注" prop="remark">
              <a-textarea placeholder="请输入备注" v-model="model.remark"></a-textarea>
            </a-form-model-item>
          </a-col>
        </a-row>
      </a-form-model>
    </j-form-container>
    <DevBpbjWarehousingListList :disabled="disabled" :triggerId="triggerId" @updateCount="updateCount" ref="list" />
  </a-spin>
</template>

<script>

  import { httpAction, getAction } from '@/api/manage'
  import { validateDuplicateValue } from '@/utils/util'
  import DevBpbjWarehousingListList from '../DevBpbjWarehousingListList'
  import moment from 'moment'
  import { mapGetters } from 'vuex'
  export default {
    name: 'DevBpbjWarehousingRecordForm',
    components: {
      DevBpbjWarehousingListList
    },
    props: {
      triggerId: {
        type: String,
        default: ''
      },
      // 表单禁用
      disabled: {
        type: Boolean,
        default: false,
        required: false
      }
    },
    data () {
      return {
        model: {
          totalAmount: 0
        },
        labelCol: {
          xs: { span: 24 },
          sm: { span: 6 }
        },
        wrapperCol: {
          xs: { span: 24 },
          sm: { span: 16 }
        },
        labelCol2: {
          xs: { span: 24 },
          sm: { span: 3 },
        },
        wrapperCol2: {
          xs: { span: 24 },
          sm: { span: 20 },
        },
        confirmLoading: false,
        validatorRules: {
          registerTime: [
            { required: true, message: '请选择登记时间!' }
          ],
          warehousingTime: [
            { required: true, message: '请选择入库时间!' }
          ]
        },
        url: {
          add: '/spareparts/devBpbjWarehousingRecord/add',
          edit: '/spareparts/devBpbjWarehousingRecord/edit',
          queryById: '/spareparts/devBpbjWarehousingRecord/queryById'
        }
      }
    },
    computed: {
      formDisabled () {
        return this.disabled
      },
      ...mapGetters(['userId', 'username'])
    },
    created () {
      // 备份model原始值
      this.modelDefault = JSON.parse(JSON.stringify(this.model))

    },
    methods: {
      moment,
      selectTz (v, attrName) {
        const { realname } = { ...v[0] }
        this.model[attrName] = realname
      },
      add () {
        this.edit(this.modelDefault)
      },
      edit (record) {
        if (!record.id) {
          const momentTime = moment().format('YYYY-MM-DD HH:mm:ss')
          record.registerTime = momentTime
          // record.headName = this.username
          record.warehousingTime = momentTime
          record.acceptorId = this.userId
          record.tzrId = this.userId

          record.headId = this.userId

        }
        this.model = Object.assign({}, record)
        this.visible = true

      },
      updateCount (v) {
        this.model.totalAmount = v
      },
      submitForm () {
        const that = this
        //   if()


        // 触发表单验证
        this.$refs.form.validate(async (valid) => {
          if (valid) {

            const vtableCheck = await this.$refs.list.handleTableCheck()

            if (!vtableCheck) return
            that.confirmLoading = true
            let httpurl = ''
            let method = ''
            let vTableData = []
            vTableData = that.$refs.list.$refs.vTable.getTableData()
            if (!this.model.id) {
              httpurl += this.url.add
              method = 'post'

              vTableData = vTableData.map(item => {
                item.bjModelId = item.id
                delete item.id
                return item
              })
            } else {
              httpurl += this.url.edit
              method = 'put'
              const editListIds = that.$refs.list.editListIds
              vTableData = vTableData.map(item => {
                if (!editListIds.includes(item.id)) {
                  delete item.id
                  item.bjModelId = item.id
                }
                return item
              })
            }
            httpAction(httpurl, {
              ...this.model,
              devBpbjWarehousingListList: vTableData,
              totalAmount: vTableData.reduce((total, item) => {
                return total + item.cost
              }, 0)
            }, method).then((res) => {
              if (res.success) {
                that.$message.success(res.message)
                that.$emit('ok')
              } else {
                that.$message.warning(res.message)
              }
            }).finally(() => {
              that.confirmLoading = false
            })
          }
        })
      }
    }
  }
</script>
<style lang="less" scoped>
  .record-model-form {
    /deep/ .ant-form-item {
      margin-bottom: 0px;
    }
  }
</style>
